/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _user_lang_level_fr = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'level',
            options: {
                knowledge: { value: [{ type: 0, value: 'Notions' }] },
                pro_limited: {
                    value: [{ type: 0, value: 'Compétence professionnelle limitée' }],
                },
                pro_full: {
                    value: [{ type: 0, value: 'Capacité professionnelle complète' }],
                },
                pro: { value: [{ type: 0, value: 'Compétence professionnelle' }] },
                native: { value: [{ type: 0, value: 'Bilingue ou langue natale' }] },
                __not_other: { value: [] },
                other: { value: [] },
            },
        },
    ],
    'fr',
);

export function user_lang_level(
    args: { level: 'knowledge' | 'native' | 'pro' | 'pro_full' | 'pro_limited' },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _user_lang_level_fr.format(args) as unknown as string;
    }

    return _user_lang_level_fr.format(args) as unknown as string;
}

const _experience_years_fr = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'experience',
            options: {
                from_0_to_2: { value: [{ type: 0, value: '0 à 2 ans' }] },
                from_2_to_5: { value: [{ type: 0, value: '2 à 5 ans' }] },
                from_0_plus: { value: [{ type: 0, value: 'Sans expérience accepté' }] },
                from_1_plus: { value: [{ type: 0, value: '1 an ou plus' }] },
                from_2_plus: { value: [{ type: 0, value: '2 ans ou plus' }] },
                from_3_plus: { value: [{ type: 0, value: '3 ans ou plus' }] },
                from_4_plus: { value: [{ type: 0, value: '4 ans ou plus' }] },
                from_5_plus: { value: [{ type: 0, value: '5 ans ou plus' }] },
                from_6_plus: { value: [{ type: 0, value: '6 ans ou plus' }] },
                from_7_plus: { value: [{ type: 0, value: '7 ans ou plus' }] },
                from_8_plus: { value: [{ type: 0, value: '8 ans ou plus' }] },
                from_9_plus: { value: [{ type: 0, value: '9 ans ou plus' }] },
                from_10_plus: { value: [{ type: 0, value: '10 ans ou plus' }] },
                __not_other: { value: [] },
                other: { value: [] },
            },
        },
    ],
    'fr',
);

export function experience_years(
    args: {
        experience:
            | 'from_0_plus'
            | 'from_0_to_2'
            | 'from_10_plus'
            | 'from_1_plus'
            | 'from_2_plus'
            | 'from_2_to_5'
            | 'from_3_plus'
            | 'from_4_plus'
            | 'from_5_plus'
            | 'from_6_plus'
            | 'from_7_plus'
            | 'from_8_plus'
            | 'from_9_plus';
    },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _experience_years_fr.format(args) as unknown as string;
    }

    return _experience_years_fr.format(args) as unknown as string;
}

const _education_level_fr = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'level',
            options: {
                none: { value: [{ type: 0, value: 'Aucun' }] },
                bep_cap: { value: [{ type: 0, value: 'Bep/cap' }] },
                bac: { value: [{ type: 0, value: 'Bac' }] },
                bac_plus_2: { value: [{ type: 0, value: 'Bac+2' }] },
                bac_plus_3: { value: [{ type: 0, value: 'Bac+3' }] },
                bac_plus_5: { value: [{ type: 0, value: 'Bac+5' }] },
                __not_other: { value: [] },
                other: { value: [] },
            },
        },
    ],
    'fr',
);

export function education_level(
    args: {
        level: 'bac' | 'bac_plus_2' | 'bac_plus_3' | 'bac_plus_5' | 'bep_cap' | 'none';
    },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _education_level_fr.format(args) as unknown as string;
    }

    return _education_level_fr.format(args) as unknown as string;
}

const _verifications_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Vérifications' }],
    'fr',
);

export function verifications(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _verifications_fr.format(args) as unknown as string;
    }

    return _verifications_fr.format(args) as unknown as string;
}

const _activity_area_fr = new IntlMessageFormat(
    [{ type: 0, value: "Secteur d'activité" }],
    'fr',
);

export function activity_area(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _activity_area_fr.format(args) as unknown as string;
    }

    return _activity_area_fr.format(args) as unknown as string;
}

const _portfolio_fr = new IntlMessageFormat([{ type: 0, value: 'Portfolio' }], 'fr');

export function portfolio(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _portfolio_fr.format(args) as unknown as string;
    }

    return _portfolio_fr.format(args) as unknown as string;
}

const _infos_fr = new IntlMessageFormat([{ type: 0, value: 'Infos' }], 'fr');

export function infos(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _infos_fr.format(args) as unknown as string;
    }

    return _infos_fr.format(args) as unknown as string;
}

const _news_fr = new IntlMessageFormat([{ type: 0, value: 'Actualités' }], 'fr');

export function news(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _news_fr.format(args) as unknown as string;
    }

    return _news_fr.format(args) as unknown as string;
}

const _experiences_fr = new IntlMessageFormat([{ type: 0, value: 'Expériences' }], 'fr');

export function experiences(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _experiences_fr.format(args) as unknown as string;
    }

    return _experiences_fr.format(args) as unknown as string;
}

const _formations_fr = new IntlMessageFormat([{ type: 0, value: 'Formations' }], 'fr');

export function formations(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _formations_fr.format(args) as unknown as string;
    }

    return _formations_fr.format(args) as unknown as string;
}

const _open_to_opportunities_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Ouvert aux opportunités' }],
    'fr',
);

export function open_to_opportunities(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _open_to_opportunities_fr.format(args) as unknown as string;
    }

    return _open_to_opportunities_fr.format(args) as unknown as string;
}

const _indicative_price_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Tarif indicatif' }],
    'fr',
);

export function indicative_price(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _indicative_price_fr.format(args) as unknown as string;
    }

    return _indicative_price_fr.format(args) as unknown as string;
}

const _indicative_price_content_fr = new IntlMessageFormat(
    [
        { type: 2, value: 'price', style: null },
        { type: 0, value: ' ' },
        { type: 1, value: 'currency' },
        { type: 0, value: '/jour' },
    ],
    'fr',
);

export function indicative_price_content(
    args: { price: number; currency: string },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _indicative_price_content_fr.format(args) as unknown as string;
    }

    return _indicative_price_content_fr.format(args) as unknown as string;
}

const _experience_fr = new IntlMessageFormat([{ type: 0, value: 'Expérience' }], 'fr');

export function experience(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _experience_fr.format(args) as unknown as string;
    }

    return _experience_fr.format(args) as unknown as string;
}

const _response_rate_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Taux de réponse' }],
    'fr',
);

export function response_rate(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _response_rate_fr.format(args) as unknown as string;
    }

    return _response_rate_fr.format(args) as unknown as string;
}

const _response_time_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Temps de réponse' }],
    'fr',
);

export function response_time(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _response_time_fr.format(args) as unknown as string;
    }

    return _response_time_fr.format(args) as unknown as string;
}

const _send_a_message_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Envoyer un message' }],
    'fr',
);

export function send_a_message(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _send_a_message_fr.format(args) as unknown as string;
    }

    return _send_a_message_fr.format(args) as unknown as string;
}

const _posts_fr = new IntlMessageFormat([{ type: 0, value: 'posts' }], 'fr');

export function posts(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _posts_fr.format(args) as unknown as string;
    }

    return _posts_fr.format(args) as unknown as string;
}

const _followers_fr = new IntlMessageFormat([{ type: 0, value: 'followers' }], 'fr');

export function followers(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _followers_fr.format(args) as unknown as string;
    }

    return _followers_fr.format(args) as unknown as string;
}

const _resume_fr = new IntlMessageFormat([{ type: 0, value: 'CV' }], 'fr');

export function resume(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _resume_fr.format(args) as unknown as string;
    }

    return _resume_fr.format(args) as unknown as string;
}

const _consult_fr = new IntlMessageFormat([{ type: 0, value: 'Consulter' }], 'fr');

export function consult(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _consult_fr.format(args) as unknown as string;
    }

    return _consult_fr.format(args) as unknown as string;
}

const _download_fr = new IntlMessageFormat([{ type: 0, value: 'Télécharger' }], 'fr');

export function download(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _download_fr.format(args) as unknown as string;
    }

    return _download_fr.format(args) as unknown as string;
}

const _my_latest_news_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Mes dernières actualités' }],
    'fr',
);

export function my_latest_news(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _my_latest_news_fr.format(args) as unknown as string;
    }

    return _my_latest_news_fr.format(args) as unknown as string;
}

const _see_all_my_news_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Voir toutes mes actualités' }],
    'fr',
);

export function see_all_my_news(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _see_all_my_news_fr.format(args) as unknown as string;
    }

    return _see_all_my_news_fr.format(args) as unknown as string;
}

const _languages_fr = new IntlMessageFormat([{ type: 0, value: 'Langues' }], 'fr');

export function languages(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _languages_fr.format(args) as unknown as string;
    }

    return _languages_fr.format(args) as unknown as string;
}

const _center_of_interest_fr = new IntlMessageFormat(
    [{ type: 0, value: "Centre d'intérêts" }],
    'fr',
);

export function center_of_interest(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _center_of_interest_fr.format(args) as unknown as string;
    }

    return _center_of_interest_fr.format(args) as unknown as string;
}

const _talents_fr = new IntlMessageFormat([{ type: 0, value: 'Talents' }], 'fr');

export function talents(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _talents_fr.format(args) as unknown as string;
    }

    return _talents_fr.format(args) as unknown as string;
}

const _businesses_fr = new IntlMessageFormat([{ type: 0, value: 'Entreprises' }], 'fr');

export function businesses(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _businesses_fr.format(args) as unknown as string;
    }

    return _businesses_fr.format(args) as unknown as string;
}

const _sectors_fr = new IntlMessageFormat([{ type: 0, value: 'Secteurs' }], 'fr');

export function sectors(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _sectors_fr.format(args) as unknown as string;
    }

    return _sectors_fr.format(args) as unknown as string;
}

const _specialties_fr = new IntlMessageFormat([{ type: 0, value: 'Spécialités' }], 'fr');

export function specialties(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _specialties_fr.format(args) as unknown as string;
    }

    return _specialties_fr.format(args) as unknown as string;
}

const _add_to_my_favorites_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Ajouter à mes favoris' }],
    'fr',
);

export function add_to_my_favorites(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _add_to_my_favorites_fr.format(args) as unknown as string;
    }

    return _add_to_my_favorites_fr.format(args) as unknown as string;
}

const _now_fr = new IntlMessageFormat([{ type: 0, value: 'Maintenant' }], 'fr');

export function now(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _now_fr.format(args) as unknown as string;
    }

    return _now_fr.format(args) as unknown as string;
}

const _verified_freelance_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Freelance vérifié' }],
    'fr',
);

export function verified_freelance(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _verified_freelance_fr.format(args) as unknown as string;
    }

    return _verified_freelance_fr.format(args) as unknown as string;
}

const _verified_email_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Email vérifié' }],
    'fr',
);

export function verified_email(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _verified_email_fr.format(args) as unknown as string;
    }

    return _verified_email_fr.format(args) as unknown as string;
}

const _gao_charter_signed_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Charte Go Africa signée' }],
    'fr',
);

export function gao_charter_signed(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _gao_charter_signed_fr.format(args) as unknown as string;
    }

    return _gao_charter_signed_fr.format(args) as unknown as string;
}

const _unknown_fr = new IntlMessageFormat([{ type: 0, value: 'Inconnu' }], 'fr');

export function unknown(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _unknown_fr.format(args) as unknown as string;
    }

    return _unknown_fr.format(args) as unknown as string;
}

const _meta_title_fr = new IntlMessageFormat(
    [
        { type: 1, value: 'name' },
        { type: 0, value: ' | Profile sur Go Africa Online' },
    ],
    'fr',
);

export function meta_title(args: { name: string }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _meta_title_fr.format(args) as unknown as string;
    }

    return _meta_title_fr.format(args) as unknown as string;
}

const _share_profile_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Partager le profil' }],
    'fr',
);

export function share_profile(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_profile_fr.format(args) as unknown as string;
    }

    return _share_profile_fr.format(args) as unknown as string;
}

const _share_profile_on_gao_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Partager le profile sur GAO' }],
    'fr',
);

export function share_profile_on_gao(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_profile_on_gao_fr.format(args) as unknown as string;
    }

    return _share_profile_on_gao_fr.format(args) as unknown as string;
}

const _share_profile_on_facebook_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Partager le profile sur GAO' }],
    'fr',
);

export function share_profile_on_facebook(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_profile_on_facebook_fr.format(args) as unknown as string;
    }

    return _share_profile_on_facebook_fr.format(args) as unknown as string;
}

const _share_profile_on_twitter_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Partager le profile sur X/Twitter' }],
    'fr',
);

export function share_profile_on_twitter(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_profile_on_twitter_fr.format(args) as unknown as string;
    }

    return _share_profile_on_twitter_fr.format(args) as unknown as string;
}

const _share_profile_on_instagram_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Partager le profile sur Instagram' }],
    'fr',
);

export function share_profile_on_instagram(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_profile_on_instagram_fr.format(args) as unknown as string;
    }

    return _share_profile_on_instagram_fr.format(args) as unknown as string;
}

const _share_profile_on_linkedin_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Partager le profile sur Linkedin' }],
    'fr',
);

export function share_profile_on_linkedin(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_profile_on_linkedin_fr.format(args) as unknown as string;
    }

    return _share_profile_on_linkedin_fr.format(args) as unknown as string;
}

const _share_profile_on_whatsapp_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Partager le profile sur Whatsapp' }],
    'fr',
);

export function share_profile_on_whatsapp(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_profile_on_whatsapp_fr.format(args) as unknown as string;
    }

    return _share_profile_on_whatsapp_fr.format(args) as unknown as string;
}

const _share_profile_on_tiktok_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Partager le profile sur Tiktok' }],
    'fr',
);

export function share_profile_on_tiktok(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_profile_on_tiktok_fr.format(args) as unknown as string;
    }

    return _share_profile_on_tiktok_fr.format(args) as unknown as string;
}
